'use strict';

const React = require('react'),
    Router = require('react-router'),
    packageJson = require('../package.json'),
    DashboardModal = require('components/DashboardModal/DashboardModal'),
    DashboardModalEl = require('components/DashboardModal/DashboardModalEl'),
    {t} = require('services/i18nextWrapper'),
    {Route, RouteHandler, DefaultRoute, NotFoundRoute} = Router,
    Constants = require('constants/AppConstants'),
    SessionStore = require('stores/SessionStore'),
    UserPermissionStore = require('stores/UserPermissionStore'),
    Security = require('services/Security').auth,
    NumberUtils = require('utils/NumberUtils'),
    NotificationEl = require('components/Notification/Notification'),
    CustomDialogEl = require('components/Commons/Dialog/CustomDialogHolder'),
    CustomContextMenu = require('components/Commons/ContextMenuCustom/ContextMenuCustom'),
    ContextMenuEl = require('components/Commons/ContextMenuCustom/ContextMenuEl'),
    Dialog = require('components/Commons/Dialog/CustomDialog'),
    ScrollLock = require('components/Commons/ScrollLock/ScrollLock'),
    UIStateStore = require('stores/UIStateStore'),
    Dashboard = require('views/Dashboard/Dashboard'),
    DashboardSpinnerEl = require('views/Dashboard/DashboardSpinnerHolder'),
    DashboardSpinner = require('views/Dashboard/DashboardSpinner'),
    Notification = require('components/Notification/Notification.jsx'),
    NotFound = require('views/Page404/Page404'),
    ReportByBeerStyle = require('views/ReportAdmin/ReportByBeerStyle/ReportByBeerStyle'),
    ReportByProduct = require('views/ReportAdmin/ReportByProduct/ReportByProduct'),
    ReportOrderByBatchNumber = require('views/ReportAdmin/ReportOrderByBatchNumber/ReportOrderByBatchNumber'),
    ReportByTask = require('views/ReportAdmin/ReportByTask/ReportByTask'),
    ReportByItemTransaction = require('views/ReportAdmin/ReportByItemTransaction/ReportByItemTransaction'),
    ReportAdmin = require('views/ReportAdmin/ReportAdmin'),
    TankAdmin = require('views/TankAdmin/TankAdmin'),
    StyleBeer = require('views/BeerStyleAdmin/BeerStyleAdmin'),
    ItemsAdmin = require('views/ItemsAdmin/ItemsAdmin'),
    NonInventoryItemsAdmin = require('views/ItemsAdmin/NonInventoryItemsAdmin'),
    SalesAdmin = require('views/SalesAdmin/SalesAdmin'),
    SalesItemsAdmin = require('views/SalesAdmin/SalesItemsAdmin'),
    CustomerAdmin = require('views/CustomerAdmin/CustomerAdmin'),
    CustomerAddressAdmin = require('views/CustomerAdmin/CustomerAddressAdmin'),
    UserAccessAdmin = require('views/UserAccess/UserAccessAdmin'),
    UserAdmin = require('views/UserAdmin/UserAdmin'),
    CustomerContactAdmin = require('views/CustomerAdmin/CustomerContactAdmin'),
    CustomerItemAdmin = require('views/CustomerAdmin/CustomerItemAdmin'),
    IconsAndSectionsAdmin = require('views/IconsAndSectionsAdmin/IconsAndSectionsAdmin'),
    IconsAdmin = require('views/IconsAdmin/IconsAdmin'),
    PasswordRecovery = require('views/PasswordRecovery/PasswordRecovery'),
    ProcessAdmin = require('views/ProcessAdmin/ProcessAdmin'),
    ProductsAdmin = require('views/ProductsAdmin/ProductsAdmin'),
    ProductItemsAdditionAdmin = require('views/ProductsAdmin/ProductItemsAdditionAdmin'),
    ProductItemsAdmin = require('views/ProductsAdmin/ProductItemsSubtractionAdmin'),
    LocationAdmin = require('views/LocationsAdmin/LocationsAdmin'),
    InventoryAndTransfersAdmin = require('views/InventoryAndTransfersAdmin/InventoryAndTransfersAdmin'),
    VendorAdmin = require('views/VendorAdmin/VendorAdmin'),
    VendorAddressAdmin = require('views/VendorAdmin/VendorAddressAdmin'),
    VendorContactAdmin = require('views/VendorAdmin/VendorContactAdmin'),
    VendorItemsAdmin = require('views/VendorAdmin/VendorItemsAdmin'),
    VendorPurchaseAdmin = require('views/VendorPurchaseAdmin/VendorPurchaseAdmin'),
    VendorPurchaseItemAdmin = require('views/VendorPurchaseAdmin/VendorPurchaseItemAdmin'),
    VendorReceiveItemAdmin = require('views/VendorPurchaseAdmin/VendorReceiveItemAdmin'),
    HistoryAdmin = require('views/HistoryAdmin/HistoryAdmin'),
    ProductIconsAdmin = require('views/ProductsAdmin/ProductIconsAdmin'),
    CheckEmailResetPassword = require('views/CheckEmailResetPassword/CheckEmailResetPassword'),
    ConfirmationResetPassword = require('views/ConfirmationResetPassword/ConfirmationResetPassword'),
    BeerStyleConfigurationAdmin = require('views/BeerStyleConfigurationAdmin/BeerStyleConfigurationAdmin'),
    Contact = require('views/Contact/Contact.jsx'),
    Help = require('views/Help/Help.jsx'),
    Login = require('views/Signin/Signin.jsx'),
    Welcome = require('views/Welcome/Welcome.jsx'),
    EmailConfirmed = require('views/EmailConfirmed/EmailConfirmed.jsx'),
    PreActivated = require('views/PreActivated/PreActivated.jsx'),
    SignUp = require('views/Signup/Signup.jsx'),
    {LeftNav, Styles} = require('material-ui'),
    {Header} = require('components/Header/Header'),
    HeaderWithBanner = require('components/Header/HeaderWithBanner'),
    ThemeManager = Styles.ThemeManager(),
    Colors = Styles.Colors,
    ga = require('react-ga');

SessionStore.isFullPaidVersion() ? require('./styles/_template.scss') : require('./styles/_templateWithBanner.scss');
require('normalize.css');
require('./styles/_fonts.scss');
require('./styles/_views.scss');
require('./styles/_components.scss');
require('./styles/_main.scss');


//////////////////////////////////////////////////////////////////////////
// SENTRY START
/////////////////////////////////////////////////////////////////////////
try {
  
  const environment = location.href.includes('localhost') || location.href.includes('127.0.0.1')
    ? 'dev'
    : location.href.includes('stage')
    ? 'stage'
    : 'prod';
  
  if (Sentry && environment === 'prod') {
    Sentry.init({
      dsn: "https://0ff9ff73324d4596a47d71ef838ea0c5@o284357.ingest.sentry.io/5645076",
      release: "bp-dashboard@" + packageJson.version,
      integrations: [
        new Sentry.Integrations.BrowserTracing()
      ],
      environment,
      // We recommend adjusting this value in production, or using tracesSampler
      // for finer control
      tracesSampleRate: 1.0
    });
    
    var oldConsoleError = console.error;
    console.error = reportingConsoleError; // defined via function hoisting
    function reportingConsoleError() {
      var args = Array.prototype.slice.call(arguments);
      Sentry.captureException(reduceConsoleArgs(args), {level: 'error'});
      return oldConsoleError.apply(console, args);
    }
    
    /*var oldConsoleWarn = console.warn;
    console.warn = reportingConsoleWarn; // defined via function hoisting
    function reportingConsoleWarn() {
      var args = Array.prototype.slice.call(arguments);
      Sentry.captureMessage(reduceConsoleArgs(args), { level: 'warning' });
      return oldConsoleWarn.apply(console, args);
    }*/
    
    function reduceConsoleArgs(args) {
      let userInfo = sessionStorage && sessionStorage.getItem ?
        ` || [${sessionStorage.getItem('cache_user_name')} - ${sessionStorage.getItem('cache_applicant_id')} - ${sessionStorage.getItem('cache_applicant_license')}]`
        : '';
      let errorMsg = args[0];
      // Make sure errorMsg is either an error or string.
      // It's therefore best to pass in new Error('msg') instead of just 'msg' since
      // that'll give you a stack trace leading up to the creation of that new Error
      // whereas if you just pass in a plain string 'msg', the stack trace will include
      // reportingConsoleError and reportingConsoleCall
      if (!(errorMsg instanceof Error)) {
        // stringify all args as a new Error (which creates a stack trace)
        errorMsg = new Error(
          args.reduce(function (accumulator, currentValue) {
            return accumulator.toString() + ' ' + currentValue.toString();
          }, '') + userInfo
        );
      }
      return errorMsg;
    }
  }
} catch(err) {
  console.error('something went wrong when try to load Sentry', err);
}

//////////////////////////////////////////////////////////////////////////
// SENTRY END
/////////////////////////////////////////////////////////////////////////

/*
 * Initialize Google Analytics
 */
ga.initialize(process.env.GOOGLE_ANALYTICS, {debug: true});

Object.assign = Object.assign || require('object-assign');

/*
 * Need Material-UI
 */
const injectTapEventPlugin = require('react-tap-event-plugin');
injectTapEventPlugin();

ThemeManager.setTheme(ThemeManager.types.LIGHT);

const HeaderSideBar = React.createClass({displayName: "HeaderSideBar",
    render: function () {
        return (
            React.createElement("div", {className: "nav-bar-header hidden-xs"}, 
                React.createElement("img", {width: "180", height: "60", src: "/assets/images/logo-small.png"}), 
                 Security.loggedIn() ? (
                    React.createElement("div", null, 
                        React.createElement("hr", null), 
                        React.createElement("div", null, SessionStore.getApplicantDisplayName())
                    )) : null
                
            )
        );
    }
});

const App = React.createClass({displayName: "App",

    getInitialState() {
        return Object.assign({}, SessionStore.getSessionData(), {isSidebarOpen: false});
    },

    contextTypes: {
        router: React.PropTypes.func
    },

    childContextTypes: {
        muiTheme: React.PropTypes.object
    },

    getChildContext() {
        return {
            muiTheme: ThemeManager.getCurrentTheme()
        };
    },

    componentWillMount() {
        SessionStore.addChangeListener(this._onChange);
        UIStateStore.addChangeListener(this._onChange);
        ThemeManager.setPalette({
            coloraccent1Color: Colors.lightBlue900,
            tableRow: {
                selected: 'red'
            }
        });
    },

    componentDidMount() {
        this.refs.leftNav.close();
        NotificationEl.setElement(this.refs.notificationEl);
        CustomDialogEl.setElement(this.refs.customDialogEl);
        DashboardModalEl.setElement(this.refs.modalOrder);
        ContextMenuEl.setElement(this.refs.contextMenuEl);
        DashboardSpinnerEl.setElement(this.refs.dashboardSpinnerEl);

        SessionStore.fetchUserInformationAndSaveIfNeeded(() => {
            NumberUtils.initializeFormat();
        });
  
        // Once i18next is load refresh the react component
      document.addEventListener('i18nextLoaded', () => {
        this.forceUpdate();
      });
    },

    componentWillUnmount() {
        SessionStore.removeChangeListener(this._onChange);
        UIStateStore.removeChangeListener(this._onChange);
    },

    _onChange() {
        this.setState(SessionStore.getSessionData());
        //sync data between stores. (need to be refectored)
    },

    _onLeftNavChange(e, key, payload) {
        e.preventDefault();
        if (SessionStore.isFullPaidVersion()) {
          this.context.router.transitionTo(payload.route, payload.param ? payload.param : undefined);
        } else {
          if (key > 5) {
            const tab = window.open(Constants.GO_PRO_URL, '_blank');
            tab.focus();
          } else {
            this.context.router.transitionTo(payload.route, payload.param ? payload.param : undefined);
          }
        }
    },

    _onTouchLeftMenuBar() {
       this.refs.leftNav.toggle();
       this._toggleStateSideber();
    },

    _onTouchRightMenuBar() {
        this.refs.rightMenu.open();
    },
  
   _toggleStateSideber() {
     this.setState(prevState => {
       return {
         isSidebarOpen: !prevState.isSidebarOpen
       };
     });
   },

    render() {
  
      const fullVersionSidebarItems = [
        {route: 'tanks/page/:page', param:{page:0}, text: t('dashboard_sidebar_tanks_sections'), iconClassName: 'icon-bar icon-tanks-sections', permission: 'ADMIN_TANK_SHOW'},
        {route: 'styleBeer', text: t('dashboard_sidebar_beer_styles'), iconClassName: 'icon-bar icon-beer-style-page-icon', permission: 'ADMIN_BEER_STYLE_SHOW'},
        {route: 'items/page/:page', param:{page:0}, text: t('dashboard_sidebar_items'), iconClassName: 'icon-bar icon-ingredients', permission: 'ADMIN_ITEM_SHOW'},
        {route: 'non-inventory-items', text: t('dashboard_sidebar_non_inventory_items'), iconClassName: 'icon-bar icon-ingredients', permission: 'ADMIN_ITEM_SHOW'},
        {route: 'products', text: t('dashboard_sidebar_products'), iconClassName: 'icon-bar icon-group-ingredients', permission: 'ADMIN_PRODUCT_SHOW'},
        {route: 'location-item/page/:page', param:{page:0}, text: t('dashboard_sidebar_inventory_transfers'), iconClassName: 'icon-bar icon-inventory-and-tranfers', permission: 'ADMIN_INVENTORY_AND_TRANSFERS_SHOW'},
        {route: 'vendors', text: t('dashboard_sidebar_suppliers'), iconClassName: 'icon-bar icon-vendors', permission: 'ADMIN_VENDOR_SHOW'},
        {route: 'purchase-item/page/:page', param: {page: 0}, text: t('dashboard_sidebar_purchase_items'), iconClassName: 'icon-bar icon-purchase-items', permission: 'ADMIN_PURCHASE_SHOW'},
        {route: 'customers', text: t('dashboard_sidebar_customers'), iconClassName: 'icon-bar icon-customers', permission: 'ADMIN_CUSTOMER_SHOW'},
        {route: 'sales/page/:page', param:{page:0}, text: t('dashboard_sidebar_sales_orders'), iconClassName: 'icon-bar icon-Sales-order', permission: 'ADMIN_SALE_SHOW'},
        {route: 'location', text: t('dashboard_sidebar_locations'), iconClassName: 'icon-bar icon-locations', permission: 'ADMIN_LOCATION_SHOW'},
        {route: 'icons-sections', text: t('dashboard_sidebar_icons_in_sections'), iconClassName: 'icon-bar icon-select-icon', permission: 'ADMIN_ICON_SHOW'},
        {route: 'user', text: t('dashboard_sidebar_users'), iconClassName: 'icon-bar icon-user-access', permission: 'ADMIN_USER_PERMISSION_SHOW'},
        {route: 'user-permissions', text: t('dsahboard_sidebar_user_access'), iconClassName: 'icon-bar icon-user-access', permission: 'ADMIN_USER_PERMISSION_SHOW'},
        {route: 'reports', text: t('dashboard_sidebar_reports'), iconClassName: 'icon-bar icon-reports', permission: 'ADMIN_REPORT_SHOW'},
        {route: 'tasks', text: t('dashboard_sidebar_tasks_qc'), iconClassName: 'icon-bar icon-process', permission: 'ADMIN_TASK_SHOW'},
        {route: 'help', text: t('dashboard_sidebar_help_contact'), iconClassName: 'icon-bar icon-help-page'} // public permission
      ];
  
      const baseVersionSidebarItems = [
        {route: 'tanks/page/:page', param:{page:0}, text: t('dashboard_sidebar_tanks_sections'), iconClassName: 'icon-bar icon-tanks-sections', permission: 'ADMIN_TANK_SHOW'},
        {route: 'styleBeer', text: t('dashboard_sidebar_beer_styles'), iconClassName: 'icon-bar icon-beer-style-page-icon', permission: 'ADMIN_BEER_STYLE_SHOW'},
        {route: 'icons-sections', text: t('dashboard_sidebar_icons_in_sections'), iconClassName: 'icon-bar icon-select-icon', permission: 'ADMIN_ICON_SHOW'},
        {route: 'tasks', text: t('dashboard_sidebar_tasks_qc'), iconClassName: 'icon-bar icon-process', permission: 'ADMIN_TASK_SHOW'},
        {route: 'help', text: t('dashboard_sidebar_help_contact'), iconClassName: 'icon-bar icon-help-page'}, // public permission
        {route: '', param: {page:0}, text: t('dashboard_sidebar_items'), iconClassName: 'icon-bar icon-ingredients is-pro-version', permission: 'ADMIN_ITEM_SHOW'},
        {route: '', text: t('dashboard_sidebar_non_inventory_items'), iconClassName: 'icon-bar icon-ingredients is-pro-version', permission: 'ADMIN_ITEM_SHOW'},
        {route: '', text: t('dashboard_sidebar_products'), iconClassName: 'icon-bar icon-group-ingredients is-pro-version', permission: 'ADMIN_PRODUCT_SHOW'},
        {route:  '', param: {page:0}, text: t('dashboard_sidebar_inventory_transfers'), iconClassName: 'icon-bar icon-inventory-and-tranfers is-pro-version', permission: 'ADMIN_INVENTORY_AND_TRANSFERS_SHOW'},
        {route:  '', text: t('dashboard_sidebar_suppliers'), iconClassName: 'icon-bar icon-vendors is-pro-version', permission: 'ADMIN_VENDOR_SHOW'},
        {route:  '', param: {page: 0}, text: t('dashboard_sidebar_purchase_items'), iconClassName: 'icon-bar icon-purchase-items is-pro-version', permission: 'ADMIN_PURCHASE_SHOW'},
        {route:  '', text: t('dashboard_sidebar_customers'), iconClassName: 'icon-bar icon-customers is-pro-version', permission: 'ADMIN_CUSTOMER_SHOW'},
        {route:  '', param:{page:0}, text: t('dashboard_sidebar_sales_orders'), iconClassName: 'icon-bar icon-Sales-order is-pro-version', permission: 'ADMIN_SALE_SHOW'},
        {route:  '', text: t('dashboard_sidebar_locations'), iconClassName: 'icon-bar icon-locations is-pro-version', permission: 'ADMIN_LOCATION_SHOW'},
        {route:  '', text: t('dashboard_sidebar_users'), iconClassName: 'icon-bar icon-user-access is-pro-version', permission: 'ADMIN_USER_PERMISSION_SHOW'},
        {route:  '', text: t('dsahboard_sidebar_user_access'), iconClassName: 'icon-bar icon-user-access is-pro-version', permission: 'ADMIN_USER_PERMISSION_SHOW'},
        {route:  '', text: t('dashboard_sidebar_reports'), iconClassName: 'icon-bar icon-reports is-pro-version', permission: 'ADMIN_REPORT_SHOW'},
      ];
      
        let menuItems = [],
            styleContainer = {};
        if (Security.loggedIn()) {
            menuItems = UserPermissionStore.filterModules(SessionStore.isFullPaidVersion() ? fullVersionSidebarItems : baseVersionSidebarItems);
            menuItems.unshift({route: 'dashboard', text:  t('dashboard_sidebar_dashboard'), iconClassName: 'icon-bar icon-dashboard-page'});
        } else {
            menuItems.push({type: 'LINK', payload: process.env.URL_API + '/#/login', text: 'Log in'});
        }

        const headerEl = React.createElement(Header, {
                onClickLeftMenuBar: this._onTouchLeftMenuBar, 
                onClickRightMenuBar: this._onTouchRightMenuBar, 
                isLogged: Security.loggedIn()}
            )

        return (
            React.createElement("div", {className: "app-main"}, 
                headerEl, 

                React.createElement("div", {id: "main", 
                     style: styleContainer }, 
                    React.createElement("div", null, 
                        React.createElement("div", {
                            id: "content", 
                            style: {
                                zIndex: 5,
                                marginTop: 0
                            }}, 
                            React.createElement(RouteHandler, null)
                        )
                    )
                ), 
                React.createElement("div", {className: "app-main__side-bar"}, 
                  React.createElement(LeftNav, {
                    ref: "leftNav", 
                    style: {fontWeight: '300'}, 
                    menuItemClassName: "app-main__side-bar-item", 
                    menuItems: menuItems, 
                    docked: false, 
                    disableSwipeToOpen: true, 
                    onChange:  this._onLeftNavChange, 
                    selectedIndex:  -1, 
                    backgroundColor:  Colors.indigo900, 
                    header: React.createElement(HeaderSideBar, null)}
                  )
                ), 
                React.createElement(DashboardSpinner, {ref: "dashboardSpinnerEl"}), 
                React.createElement(Notification, {ref: "notificationEl"}), 
                React.createElement(Dialog, {ref: "customDialogEl"}), 
                React.createElement(CustomContextMenu, {ref: "contextMenuEl"}), 
                React.createElement(DashboardModal, {ref: "modalOrder"}), 
                React.createElement(ScrollLock, null)
            )
        );
    }
});

let routes = (
    React.createElement(Route, {name: "app", handler: App, path: "/"}, 
        React.createElement(Route, {name: "login", handler: Login}), 
        React.createElement(Route, {name: "help", handler: Help}), 
        React.createElement(Route, {name: "welcome", handler: Welcome}), 
        React.createElement(Route, {name: "email-confirmed", handler: EmailConfirmed}), 
        React.createElement(Route, {name: "preActivated", handler: PreActivated}), 
        React.createElement(Route, {name: "contact", handler: Contact}), 
        React.createElement(Route, {name: "tanks/page/:page", handler: TankAdmin}), 
        React.createElement(Route, {name: "items/page/:page", handler: ItemsAdmin}), 
        React.createElement(Route, {name: "non-inventory-items", handler: NonInventoryItemsAdmin}), 
        React.createElement(Route, {name: "purchase-item/page/:page", handler: VendorPurchaseAdmin}), 
        React.createElement(Route, {name: "icons-sections", handler: IconsAndSectionsAdmin}), 
        React.createElement(Route, {name: "icons", handler: IconsAdmin}), 
        React.createElement(Route, {name: "styleBeer", handler: StyleBeer}), 
        React.createElement(Route, {name: "dashboard", handler: Dashboard}), 
        React.createElement(Route, {name: "signUp", handler: SignUp}), 
        React.createElement(Route, {name: "passwordRecovery", handler: PasswordRecovery}), 
        React.createElement(Route, {name: "history", handler: HistoryAdmin}), 
        React.createElement(Route, {name: "checkEmailResetPassword", handler: CheckEmailResetPassword}), 
        React.createElement(Route, {name: "confirmationResetPassword", handler: ConfirmationResetPassword}), 
        React.createElement(Route, {name: "styleBeer/:style/tasks", handler: BeerStyleConfigurationAdmin}), 
        React.createElement(Route, {name: "products", handler: ProductsAdmin}), 
        React.createElement(Route, {name: "location", handler: LocationAdmin}), 
        React.createElement(Route, {name: "location-item/page/:page", handler: InventoryAndTransfersAdmin}), 
        React.createElement(Route, {name: "user-permissions", handler: UserAccessAdmin}), 
        React.createElement(Route, {name: "user", handler: UserAdmin}), 
        React.createElement(Route, {name: "reports", handler: ReportAdmin}), 
        React.createElement(Route, {name: "reports/by-beer-style", handler: ReportByBeerStyle}), 
        React.createElement(Route, {name: "reports/by-products", handler: ReportByProduct}), 
        React.createElement(Route, {name: "reports/by-tasks", handler: ReportByTask}), 
        React.createElement(Route, {name: "reports/by-item-transaction", handler: ReportByItemTransaction}), 
        React.createElement(Route, {name: "reports/by-batch-number", handler: ReportOrderByBatchNumber}), 
        React.createElement(Route, {name: "vendors", handler: VendorAdmin}), 
        React.createElement(Route, {name: "sales/page/:page", handler: SalesAdmin}), 
        React.createElement(Route, {name: "sales/:saleId/items", handler: SalesItemsAdmin}), 
        React.createElement(Route, {name: "customers", handler: CustomerAdmin}), 
        React.createElement(Route, {name: "customers/:customerId/addresses", handler: CustomerAddressAdmin}), 
        React.createElement(Route, {name: "customers/:customerId/contacts", handler: CustomerContactAdmin}), 
        React.createElement(Route, {name: "customers/:customerId/items", handler: CustomerItemAdmin}), 
        React.createElement(Route, {name: "vendors/:vendorId/addresses", handler: VendorAddressAdmin}), 
        React.createElement(Route, {name: "vendors/:vendorId/contacts", handler: VendorContactAdmin}), 
        React.createElement(Route, {name: "vendors/:vendorId/items", handler: VendorItemsAdmin}), 
        React.createElement(Route, {name: "products/:productId/items", handler: ProductItemsAdmin}), 
        React.createElement(Route, {name: "products/:productId/items-addition", handler: ProductItemsAdditionAdmin}), 
        React.createElement(Route, {name: "products/:productId/icons", handler: ProductIconsAdmin}), 
        React.createElement(Route, {name: "purchase-item/:purchaseId/vendors/:vendorId", handler: VendorPurchaseItemAdmin}), 
        React.createElement(Route, {name: "purchase-item/:purchaseId/vendors/:vendorId/receive", handler: VendorReceiveItemAdmin}), 
        React.createElement(Route, {name: "processes", handler: ProcessAdmin}), 
        React.createElement(Route, {name: "tasks", handler: ProcessAdmin}), 
        React.createElement(NotFoundRoute, {handler: NotFound}), 
        React.createElement(DefaultRoute, {name: "home", handler: Login})
    )
);

Router.run(routes, Router.HashLocation, function (Handler) {
    React.render(React.createElement(Handler, null), document.getElementById('content-app'));
});



/** WEBPACK FOOTER **
 ** ./src/main.jsx
 **/